import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_42: FaireProductEntity = {
  token: "catalog_prod_prod-42",
  type: "product",
  name: "Storage Container - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 26.93,
  msrpDollars: 67.33,
  sku: "PA0042",
  caseSize: 4,
  material: "Linen",
  collectionToken: "col_pattern-play",
  isNew: true,
  isBestseller: true,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 111,
  description: "Beautiful Pattern Play piece perfect for any home.",
  categoryTokens: ["catalog_cat_home-accents"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
